"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
// inspired from https://tobbelindstrom.com/blog/resize-observer-hook/

var useResizeObserver = function useResizeObserver() {
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    observerEntry = _useState2[0],
    setObserverEntry = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    node = _useState4[0],
    setNode = _useState4[1];
  var observer = (0, _react.useRef)(null);
  var disconnect = (0, _react.useCallback)(function () {
    var _observer$current;
    return (_observer$current = observer.current) === null || _observer$current === void 0 ? void 0 : _observer$current.disconnect();
  }, []);
  var observe = (0, _react.useCallback)(function () {
    observer.current = new ResizeObserver(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
        entry = _ref2[0];
      return setObserverEntry(entry);
    });
    if (node) {
      observer.current.observe(node);
    }
  }, [node]);
  (0, _react.useLayoutEffect)(function () {
    observe();
    return function () {
      return disconnect();
    };
  }, [disconnect, observe]);
  return [setNode, observerEntry];
};
var _default = useResizeObserver;
exports["default"] = _default;